import React from 'react';
import { Typography, Card, Divider } from 'antd';
import { useLanguage } from '../i18n/LanguageContext';

const { Title, Paragraph, Text } = Typography;

const PrivacyPage: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="container">
      <Typography>
        <Title>{t('privacy.title')}</Title>
        <Paragraph>
          {t('privacy.intro')}
        </Paragraph>
      </Typography>

      <Card style={{ marginBottom: 24 }}>
        <Title level={3}>{t('privacy.info.title')}</Title>
        <Paragraph>
          <Text strong>{t('privacy.info.image.title')}</Text> {t('privacy.info.image.content')}
        </Paragraph>
        <Paragraph>
          <Text strong>{t('privacy.info.personal.title')}</Text> {t('privacy.info.personal.content')}
        </Paragraph>
        <Paragraph>
          <Text strong>{t('privacy.info.usage.title')}</Text> {t('privacy.info.usage.content')}
        </Paragraph>
        <Paragraph>
          <Text strong>{t('privacy.info.cookies.title')}</Text> {t('privacy.info.cookies.content')}
        </Paragraph>

        <Divider />

        <Title level={3}>{t('privacy.use.title')}</Title>
        <Paragraph>
          <Text strong>{t('privacy.use.service.title')}</Text> {t('privacy.use.service.content')}
        </Paragraph>
        <Paragraph>
          <Text strong>{t('privacy.use.improve.title')}</Text> {t('privacy.use.improve.content')}
        </Paragraph>
        <Paragraph>
          <Text strong>{t('privacy.use.communications.title')}</Text> {t('privacy.use.communications.content')}
        </Paragraph>

        <Divider />

        <Title level={3}>{t('privacy.security.title')}</Title>
        <Paragraph>
          {t('privacy.security.content')}
        </Paragraph>

        <Divider />

        <Title level={3}>{t('privacy.thirdparty.title')}</Title>
        <Paragraph>
          {t('privacy.thirdparty.content')}
        </Paragraph>

        <Divider />

        <Title level={3}>{t('privacy.children.title')}</Title>
        <Paragraph>
          {t('privacy.children.content')}
        </Paragraph>

        <Divider />

        <Title level={3}>{t('privacy.changes.title')}</Title>
        <Paragraph>
          {t('privacy.changes.content')}
        </Paragraph>

        <Divider />

        <Title level={3}>{t('privacy.contact.title')}</Title>
        <Paragraph>
          {t('privacy.contact.content')}
        </Paragraph>
      </Card>

      <Paragraph type="secondary">
        {t('privacy.last.updated', { date: new Date().toLocaleDateString() })}
      </Paragraph>
    </div>
  );
};

export default PrivacyPage; 